module.exports = __webpack_public_path__ + "img/icon-720deg-VR@2x.da6d99f9.png";